<template>
  <div id="app">
    <component v-bind:is="layout"></component>
  </div>
</template>
<script>
const defaultLayout = 'Default'
import localforage from 'localforage'
export default {
  mounted() {
    localforage.getItem('authtoken').then(token => {
      if(token) {
        this.$store.dispatch('auth/fetchUser', this)
        this.$store.dispatch('getMode')
        this.$store.dispatch('getCustomerType')
      }
    })
  },
  computed: {
    layout() {
      const layout = this.$route.meta.layout || defaultLayout
      return () => import(`@/layouts/${layout}.vue`)
    }
    /*
    layout() {
      return this.$store.getters.layout
    },
    /*
    theme() {
      return `theme-${process.env.VUE_APP_CLIENT}`
    },
    */
  },
}
</script>
<style lang="scss">
@import '@/assets/scss/app.scss';
</style>
